<template>
  <transition-group name="modal">
    <div
      v-for="(modal, index) in getOpenedModals"
      :key="index"
      class="modal-overlay"
    >
      <button
        type="button"
        class="modal-close"
        @click="closeModal(null)"
      >×</button>

      <component
        :is="modal.name"
        v-bind="modal.propsData"
      />
    </div>
  </transition-group>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ModalRender',
  components: {
    RepairCalculator: () => import(/* webpackChunkName: "repair-calculator" */ '@/components/modals/repairCalculator'),
    CloseRepair: () => import(/* webpackChunkName: "close-repair" */ '@/components/modals/closeRepair'),
    Confirm: () => import(/* webpackChunkName: "confirm" */ '@/components/modals/confirm'),
    CreateSale: () => import(/* webpackChunkName: "create-sale" */ '@/components/modals/createSale'),
    CreateBase: () => import(/* webpackChunkName: "create-base" */ '@/components/modals/createBase'),
    InfoBase: () => import(/* webpackChunkName: "info-base" */ '@/components/modals/infoBase'),
    ChangeBase: () => import(/* webpackChunkName: "change-base" */ '@/components/modals/changeBase'),
  },
  computed: {
    ...mapGetters('modal', ['getOpenedModals'])
  },
  watch: {
    getOpenedModals (newValue) {
      if (newValue.length > 0) {
        document.getElementsByTagName('html')[0].classList.add('overflow-hidden')

        return
      }

      document.getElementsByTagName('html')[0].classList.remove('overflow-hidden')
    }
  },
  created () {
    document.addEventListener('keydown', this.handleKeydown)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },
  methods: {
    ...mapActions('modal', ['closeModal']),
    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.closeModal()
      }
    }
  }
}
</script>

<style lang="scss" src="./style.scss" />
